import React from 'react'
import { withJsonFormsArrayControlProps } from '@jsonforms/react'
import DisplayLinkControl from '../../../grid/display-links/DisplayLinkControl'
import { Hidden } from '@mui/material'

export const DisplayLinkControlRenderer = (props) => {
    const { visible } = props
    return (
        <Hidden xsUp={!visible}>
            <DisplayLinkControl {...props} />
        </Hidden>
    )
}

export default withJsonFormsArrayControlProps(DisplayLinkControlRenderer)
